import makeStyles from '@mui/styles/makeStyles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { FormattedMessage } from 'react-intl';
import clsx from 'clsx';

const useStyles = makeStyles(theme => ({
  productGroupContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(0),
    width: '100%',
  },
}));

interface ProductGroupProps {
  groupId: string;
  color?: string;
  children?: React.ReactNode;
}

export const ProductGroup = (
  { groupId, color, children }: ProductGroupProps,
) => {
  const classes = useStyles();

  return (
    <Box
      id={`product-group-${groupId}`}
      className={clsx(
        classes.productGroupContainer,
      )}
    >
      <Box
        id={`product-group-${groupId}-header`}
        paddingTop={2}
      >
        <Typography
          variant="subtitle1"
          fontWeight={700}
          fontSize={14}
          color={color ?? '#727993'}
          borderBottom={`2px solid ${color ?? '#727993'}`}
          textTransform="uppercase"
        >
          <FormattedMessage id={`product.group.${groupId}.title`} />
        </Typography>
      </Box>
      <Box id={`product-group-${groupId}-products`}>
        {children}
      </Box>
    </Box>
  );
};
